import styleVariables from '../scss/_variables.scss';

export const TAGS_PAGE_SIZE = 25;

export const TAG_NAME_MAX_LENGTH = 50;

export const TAG_LABEL_KEY = 'tags';

export const UNIFIED_TAGS_NOTE_KEY = 'unified_tags_note';

export const DEFAULT_TAG_COLOR = styleVariables.slateGray;
